import { el, mount, unmount, setAttr } from 'redom';

import {
  computePrimaryContentDimensions,
  computeSecondaryContentDimensions,
  getVideoSettingsFromElement
} from './utilities';

/***
 * 
 * TODO:
 * 1. What will happen when a viewer joins while screen sharing?
 * 2. 
 * 
 * Known issues:
 * 1. Tabs content are not rendered as per resolution
 * 2. Recorder indicator is shown to viewer as well, when nothing was actually transmitted
 * 3. Video is cut off in the top
 * 4. Camera is on for the host, when the camera content is not transmitted
 * 
 * 
 * **/

class Stage {

  constructor(meeting, primaryVideoElement, secondaryVideoElement, width, height, parentEl) {

    this.parentEl = parentEl;
    this.stage = null;
    this.stageContext = null;
    this.primaryContentDimensions = null;
    this.secondaruContentDimensions = null;
    this.drawingStopped = true;
    this.animationFrameId = null;

    this.meeting = meeting;

    this.primaryVideoElement = primaryVideoElement;
    this.secondaryVideoElement = secondaryVideoElement;

    this.primaryContent = this.primaryVideoElement;
    this.secondaryContent = this.secondaryVideoElement;

    this.stageContainer = el('.meeting-stage-container');
    this.el = el('.meeting-stage-main', this.stageContainer);

    this.boundDraw = this.draw.bind(this);
    this.boundUpdateScreenResolution = this.updateScreenResolution.bind(this);

  }

  onmount() {

    this.initializeStage();

    this.updateScreenResolution(this.meeting);

    this.primaryVideoElement.addEventListener('loadedmetadata', this.boundUpdateScreenResolution);
    this.secondaryVideoElement.addEventListener('loadedmetadata', this.boundUpdateScreenResolution);
    this.primaryVideoElement.addEventListener('play', this.boundUpdateScreenResolution);
    this.secondaryVideoElement.addEventListener('play', this.boundUpdateScreenResolution);

    this.drawingStopped = false;
    this.draw();

  }

  onunmount() {

    this.stopDrawing();

    this.primaryVideoElement.removeEventListener('loadedmetadata', this.boundUpdateScreenResolution);
    this.secondaryVideoElement.removeEventListener('loadedmetadata', this.boundUpdateScreenResolution);
    this.primaryVideoElement.removeEventListener('play', this.boundUpdateScreenResolution);
    this.secondaryVideoElement.removeEventListener('play', this.boundUpdateScreenResolution);

    if (this.stageContext !== null) {
      this.stageContext.clearRect(0, 0, this.stage.width, this.stage.height);
      this.stageContext = null;
    }

    unmount(this.stageContainer, this.stage);
    this.stage = null;
    this.primaryContent = null;
    this.secondaryContent = null;

  }

  getDimensions() {

    const containerDimensions = {
      width: this.el.offsetWidth,
      height: this.el.offsetHeight
    };

    const hostVideoSettings = this.meeting.hostVideoSettings;

    return computePrimaryContentDimensions(containerDimensions, hostVideoSettings);

  }

  displayPrimaryContentAsPrimary() {

    this.primaryContent = this.primaryVideoElement;

    this.secondaryContent = this.secondaryVideoElement;

    this.updateScreenResolution(this.meeting);

  }

  displaySecondaryContentAsPrimary() {

    this.primaryContent = this.secondaryVideoElement;

    this.secondaryContent = this.primaryVideoElement;

    this.updateScreenResolution(this.meeting);

  }

  initializeStage() {

    this.stage = el('canvas');
    this.stageContext = this.stage.getContext('2d');

    mount(this.stageContainer, this.stage);

  }

  drawPrimaryContent() {

    const dimensions = this.primaryContentDimensions;

    if (!dimensions || !this.primaryContent) {
      return;
    }

    if (this.primaryContent.videoWidth === 0 || this.primaryContent.videoHeight === 0) {
      return;
    }

    this.stageContext.drawImage(this.primaryContent, dimensions.x, dimensions.y, dimensions.width, dimensions.height);

  }

  drawSecondaryContent() {

    const dimensions = this.secondaryContentDimensions;

    if (!dimensions || !this.secondaryContent) {
      return;
    }

    if (this.secondaryContent.videoWidth === 0 || this.secondaryContent.videoHeight === 0) {
      return;
    }

    this.stageContext.drawImage(this.secondaryContent, dimensions.x, dimensions.y, dimensions.width, dimensions.height);

  }

  draw() {

    const containerDimensions = {
      width: this.el.offsetWidth,
      height: this.el.offsetHeight
    };

    const newWidth = containerDimensions.width;
    const newHeight = containerDimensions.height - 5;

    if (this.stage.width !== newWidth || this.stage.height !== newHeight) {
      this.stage.width = newWidth;
      this.stage.height = newHeight;
    } else {
      this.stageContext.clearRect(0, 0, this.stage.width, this.stage.height);
    }

    this.drawPrimaryContent();
    this.drawSecondaryContent();

    if (this.isDrawingStopped() === true) {
      return;
    }

    this.animationFrameId = window.requestAnimationFrame(this.boundDraw);

  }

  isDrawingStopped() {

    return this.drawingStopped;

  }

  stopDrawing() {

    this.drawingStopped = true;

    if (this.animationFrameId !== null) {
      window.cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    }

  }

  getCanvas() {

    return this.stage;

  }

  updateScreenResolution(meeting) {

    this.meeting = meeting;

    const containerDimensions = {
      width: this.el.offsetWidth,
      height: this.el.offsetHeight
    };

    const primaryVideoSettings = getVideoSettingsFromElement(this.primaryContent);
    const secondaryVideoSettings = getVideoSettingsFromElement(this.secondaryContent);

    this.primaryContentDimensions = computePrimaryContentDimensions(containerDimensions, primaryVideoSettings);
    this.secondaryContentDimensions = computeSecondaryContentDimensions(containerDimensions, secondaryVideoSettings);

  }

}

export default Stage;